import type { AccountType } from '../types';
import { homePath } from './verification';

export const SESSION_HOME_EVENT = 'passport:open-home';

/** Asks the open app to show this role's home without a full browser reload. */
export function openRoleHome(accountType: AccountType): void {
  const path = homePath(accountType);
  const event = new CustomEvent(SESSION_HOME_EVENT, {
    cancelable: true,
    detail: { path },
  });
  window.dispatchEvent(event);
  if (event.defaultPrevented) return;

  if (window.location.pathname === path) {
    window.location.reload();
    return;
  }
  window.location.assign(path);
}
